export default "__VITE_ASSET__Br4_MFvs__"